import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  FORGOT_PASSWORD,
  LOAD_NOTIFICATION,
  LOAD_NOTIFICATION_TYPES,
  LOAD_ORGANIZATION_LIST,
  LOAD_TRANSPORT_LIST,
  LOAD_REPRESENTATIVE_LIST, CREATE_REPRESENTATIVE, LOAD_REPRESENTATIVE_BY_ID, EDIT_REPRESENTATIVE,
} from './actions';
import {
  LOCAL_STORAGE_APPLICANT_KEY,
  LOCAL_STORAGE_AUTHORIZED_KEY,
  LOCAL_STORAGE_AUTHORIZED_SESSION_KEY,
  LOCAL_STORAGE_COMPANY_KEY,
} from '../../configs/names';
import { AUTHORIZED_MODULE, SETTINGS_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
} from '../../utils/getCrudConfig';
import AuthorizedDTO from '../../dto/AuthorizedDTO';
import { esiaReducer, esiaState } from './esia.reducer';

const getToken = () => {
  try {
    return window.localStorage.getItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY) || null;
  } catch (e) {
    return null;
  }
};

export const setStorageAuthorized = token => {
  window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY, token);
};
export const clearStorageAuthorized = () => {
  window.localStorage.removeItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY);
  window.localStorage.removeItem(LOCAL_STORAGE_COMPANY_KEY);
  window.localStorage.removeItem(LOCAL_STORAGE_AUTHORIZED_KEY);
  window.localStorage.removeItem(LOCAL_STORAGE_APPLICANT_KEY);
};

const getUser = () => {
  try {
    const result = window.localStorage.getItem(LOCAL_STORAGE_AUTHORIZED_KEY);
    return result ? JSON.parse(result) : {};
  } catch (e) {
    return {};
  }
};

const getCompany = () => {
  try {
    const result = window.localStorage.getItem(LOCAL_STORAGE_COMPANY_KEY);
    return result ? JSON.parse(result) : '';
  } catch (e) {
    return {};
  }
};

const token = getToken() || null;
const user = getUser() || null;
const company = getCompany() || null;
// if (!client.id || !token) {
if (!token) {
  clearStorageAuthorized();
}
const initialState = {
  loggedIn: !!token && !!company,
  // loggedIn: true,
  // loggedIn: false,
  loginProcess: false,
  authorizedData: getUser(),
  token,
  loadingForgotPassword: false,
  transportList: [],
  loadingTransportList: false,
  organizationList: [],
  notificationMeta: {},
  notification: [],
  notificationTypeList: [],
  loadingNotification: false,
  loadingNotificationType: false,
  representativeList: [],
  loadingRepresentativeList: false,
  loadingCreateRepresentative: false,
  representativeListMeta: {},
  loadingEditRepresentative: false,
  ...esiaState,
  representative: {},
  currentCompany: company,
};

const reducer = handleActions({
  ...createOperationStateReducer(AUTHORIZED_MODULE + FORGOT_PASSWORD, 'loadingForgotPassword'),
  ...createLoadListReducerWithBegin(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_BY_ID, 'representative', 'loadingRepresentative'),
  ...createLoadListReducerWithBegin(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_LIST, 'representativeList', 'loadingRepresentativeList'),
  ...createLoadListReducerWithBegin(AUTHORIZED_MODULE + LOAD_NOTIFICATION, 'notification', 'loadingNotification'),
  ...createLoadListReducerWithBegin(AUTHORIZED_MODULE + LOAD_TRANSPORT_LIST, 'transportList', 'loadingTransportList'),
  ...createOperationStateReducer(AUTHORIZED_MODULE + CREATE_REPRESENTATIVE, 'loadingCreateRepresentative'),
  ...createLoadListReducerWithBegin(AUTHORIZED_MODULE + LOAD_ORGANIZATION_LIST, 'organizationList', 'loadingOrganizationList'),
  ...createLoadListReducerWithBegin(AUTHORIZED_MODULE + LOAD_NOTIFICATION_TYPES, 'notificationTypeList', 'loadingNotificationType'),
  ...createOperationStateReducer(AUTHORIZED_MODULE + EDIT_REPRESENTATIVE, 'loadingEditRepresentative'),
  // ...asuGptReducer,
  ...esiaReducer,
}, initialState);

export default reducer;

export const getAuthorizedData = createSelector([state => state[AUTHORIZED_MODULE]], state => new AuthorizedDTO(state));

export const getLoginProcess = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => state.loginProcess || false,
);

export const getClientPersonalData = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => state.authorizedData,
);

export const getClientCompanyData = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => state.currentCompany,
);

export const getProfileData = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => {
    const {
      loadingNotification,
      transportList,
      loadingTransportList,
      organizationList,
      loadingOrganizationList,
      representativeList,
      loadingRepresentativeList,
      representativeListMeta,
      loadingCreateRepresentative,
      representative,
      loadingEditRepresentative,
    } = state;

    return {
      representativeList,
      loadingRepresentativeList,
      representativeListMeta,
      loadingNotification,
      transportList,
      loadingTransportList,
      organizationList,
      loadingOrganizationList,
      loadingCreateRepresentative,
      representative,
      loadingEditRepresentative,
    };
  },
);

export const getNotificationData = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => ({
    notificationMeta: state.notificationMeta,
    notification: state.notification,
    loadingNotification: state.loadingNotification,
    notificationTypeList: state.notificationTypeList,
    loadingNotificationType: state.loadingNotificationType,
  }),
);
